// TipEnums.ts (recommended)
export enum DeliveryPlatformEnum {
  // System = "system",
  App = "app",
}

export enum PriorityEnum {
  Low = 1,
  Medium = 2,
  High = 3,
}

export enum FrequencyEnum {
  Daily = "Daily",
  Weekly = "Weekly",
  Monthly = "Monthly",
  Custom = "Custom",
}
